var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { featherInternalLocaleIdentifier } from '..';
import { allLocales, } from '../../../models';
import { setCookieLocale } from '../setCookieLocale';
import { getCookie } from 'cookies-next';
export function detectLocale(param) {
    var navigatorLanguage;
    var allowDebugLanguages;
    var cookieDomain;
    if (typeof param === 'string') {
        navigatorLanguage = param;
    }
    if (typeof param === 'object') {
        navigatorLanguage = param.navigatorLanguage;
        allowDebugLanguages = param.allowDebugLanguages;
        cookieDomain = param.cookieDomain;
    }
    var cookieLocale = getCookie(featherInternalLocaleIdentifier);
    var defaultLocale = 'en';
    var allowedLocales = __spreadArray(__spreadArray([], allLocales, true), (allowDebugLanguages ? ['xx', 'cimode'] : []), true);
    if (cookieLocale &&
        allowedLocales.includes(cookieLocale)) {
        // Set cookie again to automatically remove duplicates
        setCookieLocale(cookieLocale, cookieDomain);
        return cookieLocale;
    }
    var matchedLocale = allowedLocales.find(function (locale) {
        var regex = new RegExp("^".concat(locale, "\\b"), 'g');
        return regex.test(navigatorLanguage || navigator.language);
    });
    if (matchedLocale) {
        setCookieLocale(matchedLocale, cookieDomain);
        return matchedLocale;
    }
    setCookieLocale(defaultLocale, cookieDomain);
    return 'en';
}
